import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import {
  AddCompanyData,
  companiesMap,
  dropDowns,
  initialstep,
  nextstep,
  previousstep,
  setloader,
  setsteps,
  UpdateCompanyData,
} from "../../store/reducers";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Formik, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Map from "../Map";
import Other from "./components/Other";
import { toast } from "react-toastify";
import { Textarea } from "@mui/joy";

function AddCompany() {
  const { step } = useSelector((state) => state.counter);
  const [loading, setloading] = useState(false);

  const dropdownRef = useRef(null);
  const location = useLocation();
  const editData = location.state?.data;
  const dragable = true;
  const [minlength, setminlength] = useState(editData?.min_length || '');
  const [bidlog, setbidlog] = useState(editData?.accept_bid_logs || false);
  const [speciespref, setspeciespref] = useState(editData?.species_preference || '');
  const [diapref, setdiapref] = useState(editData?.diameter_preference || '');
  const [maxdia, setmaxdia] = useState(editData?.max_diameter || '');
  const [mindia, setmindia] = useState(editData?.min_diameter || '');
  const [maxlength, setmaxlength] = useState(editData?.max_length || '');
  const [annualproduction, setannualproduction] = useState(editData?.annual_production || '');
  const [notes, setnotes] = useState(editData?.notes || '');
  const [lengthpref, setlengthpref] = useState(editData?.length_preference || '');


  console.log('editData', editData?.x, editData?.y);
  console.log('annualproduction', annualproduction);


  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(initialstep());
  }, []);

  const handlestep = (index) => {
    // Steps that can be accessed freely after step 0 is completed
    const allowedSteps = [1, 2, 3, 4, 5, 6];

    // Ensure Step 0 is completed before moving forward
    if (step === 0) {
      toast.error(" You must complete Company Info before proceeding.");
      return;
    }

    // Ensure Step 7 is completed before allowing navigation to Step 8 or 9
    if (index >= 8 && step < 7) {
      toast.error("You must complete Company Contacts before proceeding.");
      return;
    }

    // Prevent jumping from Step 7 directly to Step 8 or 9 without completing Step 7
    if (step === 7 && (index === 8 || index === 9)) {
      toast.error("You must complete Company Contacts before proceeding.");
      return;
    }

    // Allow moving from Step 8 to Step 9
    if (step === 8 && index === 9) {
      dispatch(setsteps(index));
      return;
    }

    // Allow navigation to any previous step or allowed steps
    if (allowedSteps.includes(step) || index <= step) {
      dispatch(setsteps(index));
    }
  };

  const steps = [
    "Company Info",
    "Products Purchased",
    "Products Produced",
    "Species",
    "Services",
    "Equipment",
    "Log Buying Preferences",
    "Company Contacts",
    "Certifications",
    "Company location",
  ];
  const states = ["California", "Nevada", "Oregon"];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [istablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1023);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1023);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const handleRegionSelect = (regionName, areas, setFieldValue, values) => {
    if (areas.length === 0) {
      // Toggle regionName in values.county
      const updatedCounty = values.county.includes(regionName)
        ? values.county.filter((item) => item !== regionName)
        : [...values.county, regionName];
      setFieldValue("county", updatedCounty);
    } else {
      // Handle areas logic as before
      const allAreasSelected = areas.every((area) => values.county.includes(area));
      const updatedCounty = allAreasSelected
        ? values.county.filter((county) => !areas.includes(county))
        : [...values.county, ...areas.filter((area) => !values.county.includes(area))];
      setFieldValue("county", updatedCounty);
    }
  };

  const handleAreaSelect = (area, setFieldValue, values) => {
    const alreadySelected = values.county?.includes(area);

    setFieldValue(
      "county",
      alreadySelected
        ? values.county.filter((a) => a !== area) // Deselect area
        : [...values.county, area] // Select area
    );
  };

  const handleCancel = () => {
    navigate("/dashboard");
  };

  const [companyContacts, setCompanyContacts] = useState(
    editData?.company_contacts || [
      { name: "", email: "", phone: "", website: "" },
    ]
  );

  const initialValues = {
    name: editData?.name || "",
    address: editData?.street_address || "",
    address2: editData?.address_line_2 || "",
    city: editData?.city || "",
    state: editData?.state || "California",
    zip: editData?.zip || "",
    physical_address: "",
    manual_physical_address: false,
    county: editData?.region || [],
    company_overview: editData?.company_overview || "",
    revision_log_message: editData?.revision_log_message || "",
    products_produced: [],
    products_purchased: [],
    services: [],
    species: [],
    equipments: [],

    accept_bid_logs: editData?.accept_bid_logs || false,
    speciesPreference: editData?.species_preference || "",
    diameter_preference: editData?.diameter_preference || "",
    length_preference: editData?.length_preference || "",
    max_diameter: editData?.max_diameter || "",
    min_diameter: editData?.min_diameter || "",
    max_length: editData?.max_length || "",
    min_length: editData?.min_length || "",
    annual_production: editData?.annual_production || "",
    notes: editData?.notes || "",

    certifications: [],
    company_contacts: companyContacts,
    x: editData?.x || "",
    y: editData?.y || "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    zip: Yup.string().required("ZipCode is required"),
    state: Yup.string().required("State is required"),
    county: Yup.array()
      .min(1, "At least one region/area must be selected")
      .required("Region/County is required"),

    company_contacts: Yup.lazy((value) => {
      if (step === 7) {
        return Yup.array().of(
          Yup.object().shape({
            name: Yup.string().required("Name is required"),
            email: Yup.string()
              .email("Invalid email format")
              .required("Email is required"),
            phone: Yup.string()
              .matches(
                /^\d{10}$/,
                "Phone number is not valid"
              )
              .required("Phone is required"),


          })
        );
      }
      return Yup.array().notRequired();
    }),
  });


  const [coords, setCoords] = useState({});
  const [payload, setPayload] = useState({});

  const onSubmit = (values) => {
    if (values) {
      values.region = values?.county;
      values.street_address = values?.address;
      values.address_line_2 = values?.address2;
      values.species_preference = values?.speciesPreference;
      values.complete_physical_address =
        values?.physical_address ||
        [
          values.address,
          values.address2,
          values.city,
          values.county && `${values.county}`,
          values.state,
          values.zip,
        ]
          .filter(Boolean) // Filter out empty values
          .join(", "); // Join with a comma and space
    }
    setPayload(values);
    dispatch(nextstep());
    if (!editData) {
      if (step === 0) {
        const payload = {
          address: `${values.street_address}, ${values?.city}, ${values.state}, ${values.zip}`,
        };
        dispatch(companiesMap(payload)).then((response) => {
          setCoords(response?.payload);
        });
      }
    }
  };
  console.log('coords', coords);

  const handleSave = () => {
    if (editData) {
      payload.id = editData?.id;
    }

    payload.products_produced = Produced;
    payload.products_purchased = Purchased;
    payload.species = Species;
    payload.services = Services;
    payload.equipments = Equipment;
    payload.certifications = certifications;
    payload.company_contacts = companyContacts;
    payload.x = coords?.x || editData.x;
    payload.y = coords?.y || editData.y;
    payload.accept_bid_logs = bidlog;
    payload.min_length = minlength;
    payload.species_preference = speciespref;
    payload.diameter_preference = diapref;
    payload.max_diameter = maxdia;
    payload.min_diameter = mindia;
    payload.max_length = maxlength;
    payload.annual_production = annualproduction;
    payload.notes = notes;
    payload.length_preference = lengthpref;



    delete payload.manual_physical_address;
    delete payload.address;
    delete payload.address2;
    delete payload.physical_address;
    delete payload.county;
    delete payload.speciesPreference;
    console.log('payload', payload);

    if (editData) {
      setloading(true);
      dispatch(UpdateCompanyData(payload))
        .then((data) => {

          if (data.meta.requestStatus === "fulfilled") {
            toast.success(data?.payload);
            navigate("/my-company");
          } else {
            toast.error("Something is wrong");
            navigate("/my-company");
          }
          setloading(false);
        })
        .catch(() => {
          // navigate("/");
          setloading(false);
        });
    } else {
      setloading(true);
      dispatch(AddCompanyData(payload)).then((data) => {
        if (data?.payload) {
          toast.success(data?.payload);
          navigate("/dashboard");
        }
        setloading(false);
      });
    }
  };

  useEffect(() => {
    
    dispatch(dropDowns()).then((res) => {
      setData(res.payload);
    });
  }, []);

  const [isOpen, setIsOpen] = useState({
    section1: true,
    section2: true,
    section3: true,
    section4: true,
    section5: true,
    section6: true,
    section7: true,
    section8: true,
    section9: true,
  });

  const toggleCollapse = (section) => {
    setIsOpen((prevState) => ({
      ...prevState,
      [section]: !prevState[section], // Toggle the current section
    }));
  };

  const [otherCheck1, setOtherCheck1] = useState(false);
  const [otherValue1, setOtherValue1] = useState("");
  const [Purchased, setPurchased] = useState(
    editData?.products_purchased || []
  );
  const PurchasedChange = (product) => {
    setPurchased((prev) =>
      prev?.includes(product)
        ? prev.filter((item) => item !== product)
        : [...prev, product]
    );
  };
  const [unmatchedValues1, setUnmatchedValues1] = useState([]);

  useEffect(() => {
    if (data?.wood_products) {
      const allOptions1 = [
        ...(data.wood_products["Timber Products"] ?? []),
        ...(data.wood_products["Non-timber and Special Forest Products"] ?? []),
      ];
  
      const unmatched = (Purchased || []).filter(
        (item) => !allOptions1.includes(item)
      );
  
      setUnmatchedValues1(unmatched);
      setOtherCheck1(unmatched.length > 0);
      setOtherValue1(unmatched.join(", "));
    }
  }, [data, Purchased]);


  const [otherCheck2, setOtherCheck2] = useState(false);
  const [otherValue2, setOtherValue2] = useState("");
  const [Produced, setProduced] = useState(editData?.products_produced || []);
  const ProducedChange = (product) => {
    setProduced((prev) =>
      prev?.includes(product)
        ? prev.filter((item) => item !== product)
        : [...prev, product]
    );
  };


  const [unmatchedValues2, setUnmatchedValues2] = useState([]);

  useEffect(() => {
    if (data?.wood_products) {
      const allOptions2 = [
        ...(data.wood_products["Timber Products"] ?? []),
        ...(data.wood_products["Non-timber and Special Forest Products"] ?? []),
      ];
  
      const unmatched = (Produced || []).filter(
        (item) => !allOptions2.includes(item)
      );
  
      setUnmatchedValues2(unmatched);
      setOtherCheck2(unmatched.length > 0);
      setOtherValue2(unmatched.join(", "));
    }
  }, [data, Produced]);


  React.useEffect(() => {
    if (editData) {
      if (Array.isArray(unmatchedValues2) && unmatchedValues2.length > 0) {
        const hasUnmatched = unmatchedValues2.length > 0;
        setOtherCheck2(hasUnmatched);
        setOtherValue2(hasUnmatched ? unmatchedValues2.join(", ") : "");
      }
      else {

        setOtherCheck2(unmatchedValues2.length > 0 || otherCheck2);
        setOtherValue2(unmatchedValues2.join(", "));

      }
    } else {
      setOtherCheck2(unmatchedValues2.length > 0 || otherCheck2);
      setOtherValue2(unmatchedValues2.join(", "));

    }
  }, [unmatchedValues2]);

  console.log('unmatchedValues2', unmatchedValues2, 'otherCheck2', otherCheck2);

  const [otherCheck3, setOtherCheck3] = useState(false);
  const [otherValue3, setOtherValue3] = useState("");

  const [Species, setSpecies] = useState(editData?.species || []);
  const SpeciesChange = (product) => {
    setSpecies((prev) =>
      prev?.includes(product)
        ? prev.filter((item) => item !== product)
        : [...prev, product]
    );
  };
  const [unmatchedValues3, setUnmatchedValues3] = useState([]);

  useEffect(() => {
    if (data?.wood_products) {
      const allOptions3 = [
        ...(data?.species["Softwoods"] ?? []),
          ...(data?.species["Hardwoods"] ?? []),
      ];
  
      const unmatched = (Species || []).filter(
        (item) => !allOptions3.includes(item)
      );
  
      setUnmatchedValues3(unmatched);
      setOtherCheck3(unmatched.length > 0);
      setOtherValue3(unmatched.join(", "));
    }
  }, [data, Species]);

  // const allOptions3 = [
  //   ...(data?.species["Softwoods"] ?? []),
  //   ...(data?.species["Hardwoods"] ?? []),
  // ];
  // const unmatchedValues3 = (Species || []).filter(
  //   (item) => !(allOptions3 || []).includes(item)
  // );
  // React.useEffect(() => {
  //   setOtherCheck3(unmatchedValues3.length > 0 || otherCheck3);
  //   setOtherValue3(unmatchedValues3.join(", "));
  // }, [unmatchedValues3]);

  const [otherCheck4, setOtherCheck4] = useState(false);
  const [otherValue4, setOtherValue4] = useState("");

  const [Services, setServices] = useState(editData?.services || []);
  const ServicesChange = (service) => {
    setServices((prev) =>
      prev?.includes(service)
        ? prev.filter((item) => item !== service)
        : [...prev, service]
    );
  };

  const [unmatchedValues4, setUnmatchedValues4] = useState([]);

  useEffect(() => {
    if (data?.wood_products) {
      const allOptions4 = [
        ...(data?.services["Forestry Services"] ?? []),
        ...(data?.services["Manufacturing / Secondary manufacturing"] ?? []),
      ];
  
      const unmatched = (Services || []).filter(
        (item) => !allOptions4.includes(item)
      );
  
      setUnmatchedValues4(unmatched);
      setOtherCheck4(unmatched.length > 0);
      setOtherValue4(unmatched.join(", "));
    }
  }, [data, Services]);

  // const allOptions4 = [
  //   ...(data?.services["Forestry Services"] ?? []),
  //   ...(data?.services["Manufacturing / Secondary manufacturing"] ?? []),
  // ];
  // const unmatchedValues4 = (Services || []).filter(
  //   (item) => !(allOptions4 || []).includes(item)
  // );
  // React.useEffect(() => {
  //   setOtherCheck4(unmatchedValues4.length > 0 || otherCheck4);
  //   setOtherValue4(unmatchedValues4.join(", "));
  // }, [unmatchedValues4]);

  const [otherCheck5, setOtherCheck5] = useState(false);
  const [otherValue5, setOtherValue5] = useState("");

  const [Equipment, setEquipment] = useState(editData?.equipments || []);
  const EquipmentChange = (item) => {
    setEquipment((prev) =>
      prev?.includes(item)
        ? prev.filter((equip) => equip !== item)
        : [...prev, item]
    );
  };

  const [unmatchedValues5, setUnmatchedValues5] = useState([]);

  useEffect(() => {
    if (data?.wood_products) {
      const allOptions5 = [...(data?.equipments ?? [])];
  
      const unmatched = (Equipment || []).filter(
        (item) => !allOptions5.includes(item)
      );
  
      setUnmatchedValues5(unmatched);
      setOtherCheck5(unmatched.length > 0);
      setOtherValue5(unmatched.join(", "));
    }
  }, [data, Equipment]);

  // const allOptions5 = [...(data?.equipments ?? [])];
  // const unmatchedValues5 = (Equipment || []).filter(
  //   (item) => !(allOptions5 || []).includes(item)
  // );
  // React.useEffect(() => {
  //   setOtherCheck5(unmatchedValues5.length > 0 || otherCheck5);
  //   setOtherValue5(unmatchedValues5.join(", "));
  // }, [unmatchedValues5]);

  const [otherCheck8, setOtherCheck8] = useState(false);
  const [otherValue8, setOtherValue8] = useState("");

  const [certifications, setCertifications] = useState(
    editData?.certifications || []
  );
  const handleCertificationChange = (item) => {
    setCertifications((prev) =>
      prev?.includes(item)
        ? prev.filter((cert) => cert !== item)
        : [...prev, item]
    );
  };

  const [unmatchedValues8, setUnmatchedValues8] = useState([]);

  useEffect(() => {
    if (data?.wood_products) {
      const allOptions8 = [...(data?.certifications ?? [])];
  
      const unmatched = (certifications || []).filter(
        (item) => !allOptions8.includes(item)
      );
  
      setUnmatchedValues8(unmatched);
      setOtherCheck8(unmatched.length > 0);
      setOtherValue8(unmatched.join(", "));
    }
  }, [data, certifications]);

  // const allOptions8 = [...(data?.certifications ?? [])];
  // const unmatchedValues8 = (certifications || []).filter(
  //   (item) => !(allOptions8 || []).includes(item)
  // );
  // React.useEffect(() => {
  //   setOtherCheck8(unmatchedValues8.length > 0 || otherCheck8);
  //   setOtherValue8(unmatchedValues8.join(", "));
  // }, [unmatchedValues8]);


  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?accept-language=en&countrycodes=us&q=${encodeURIComponent(
          query
        )}%20California%20United%20States&format=json`
      );
      const data = await response.json();

      setSuggestions(data);
      setShowDropdown(true);
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
    }
  };
  const handleSelectSuggestion = (suggestion, setFieldValue) => {
    console.log('suggestion', suggestion);


    setFieldValue("address", suggestion?.display_name);
    fetchLocationDetails(suggestion.lat, suggestion.lon, setFieldValue);
    setSuggestions([]);
    setShowDropdown(false);
  };

  const fetchLocationDetails = async (lat, lon, setFieldValue) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`
      );
      const data = await response.json();

      if (data.address) {
        const city = data?.address.city
        const state = data?.address.state
        const county = data?.address.county
        const zipcode = data.address.postcode
        const US = 'United States'
        const CA = 'California'
        const address = data.display_name
        // console.log('data for split', data?.address.county);
        handlesplitaddress(city, state, county, zipcode, US, CA, address, setFieldValue)
        setFieldValue("zip", data.address.postcode || "");


        // setFieldValue("selectedCounty", matchedCounty || countyName);
        setFieldValue("city", data.address.city || data.address.town || "");

      }
    } catch (error) {
      console.error("Error fetching location details:", error);
    }
  };

  const handlesplitaddress = (city, state, county, zipcode, US, CA, address, setFieldValue) => {
    // console.log('split', city, state, matchedCounty, zipcode, US, CA, address);
    let addressParts = address.split(",").map(part => part.trim());
    let uniqueParts = new Set(addressParts);
    [city, state && state.replace(/[{}]/g, ""), county, zipcode, US, CA].forEach(item => {
      if (item) uniqueParts.delete(item);
    });
    const updatedAddress = Array.from(uniqueParts).join(", ");
    console.log('updatedAddress', updatedAddress);
    setFieldValue("address", updatedAddress);
  }





  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent background
            zIndex: 1000, // Ensure loader stays on top
          }}
        >
          <CircularProgress style={{ color: "#4A5E00" }} />
        </div>
      )}
      {/* <div className="modal_ul_main"> */}
      <div style={{ display: "flex" }} className="step-con">
        <div
          style={{ width: "20%", margin: "2em 0em 0em 5em" }}
          className="stepp-width"
        >
          <h4 style={{ margin: "1em 0em" }}>
            {editData ? "Edit Company" : "Add Company"}
          </h4>
          <Box
            sx={{
              overflowX: isMobile ? "auto" : "unset",
              width: isMobile ? "100%" : "30em",
              display: "flex",
              justifyContent: isMobile ? "flex-start" : "center",
            }}
          >
            <Stepper
              activeStep={step}
              orientation={(isMobile || istablet) ? "horizontal" : "vertical"}
              alternativeLabel={isMobile}
              style={{ width: isMobile ? "auto" : "30em" }}
              className="pro-width"
            >
              {steps?.map((label, index) => (
                <Step key={index} onClick={() => handlestep(index)}>
                  <StepLabel style={{ cursor: 'pointer' }} className="text-capitalize">{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>

        <div style={{ width: "70%" }} className="stepp-width">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnBlur={true}   // Validate on blur (when field loses focus)
            validateOnChange={false}
            onSubmit={onSubmit}
          >
            {({ values, errors, touched, setFieldValue, handleChange, handleBlur }) => (
              <Form>
                <div className="container text-start p-3" style={{ marginTop: '4em' }}>
                  {/* company Information */}
                  {step === 0 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Company Information
                        </Typography>
                        <div className="col-12 col-md-6">
                          <b>Name *</b>
                          <input
                            type="text"
                            className={`form-control ${touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            id="companyName"
                            name="name"
                            value={values.name}
                            onChange={(e) => {
                              setFieldValue("name", e.target.value);
                            }}
                          />
                          {touched.name && errors.name && (
                            <div className="text-danger">{errors.name}</div>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <b>Street Address *</b>
                          {/* <input
                            type="text"
                            className={`form-control ${touched.address && errors.address
                              ? "is-invalid"
                              : ""
                              }`}
                            id="address"
                            name="address"
                            value={values.address}
                            onChange={(e) => {
                              setFieldValue("address", e.target.value);
                            }}
                          />
                          {touched.address && errors.address && (
                            <div className="text-danger">
                              {errors.address}
                            </div>
                          )} */}
                          <Field
                            name="address"
                            placeholder="Address"
                            className={`form-control ${touched.address && errors.address ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              setFieldValue("address", e.target.value);
                              fetchSuggestions(e.target.value); // Fetch address suggestions
                            }}
                          />
                          <ErrorMessage component="div" name="address" className="invalid-feedback" />
                          {showDropdown && suggestions?.length > 0 && (
                            <ul className="dropdown-menu show w-100" style={{ maxHeight: "200px", overflowY: "auto" }} ref={dropdownRef}>
                              {suggestions.map((suggestion, index) => (
                                <li
                                  key={index}
                                  className="dropdown-item"
                                  onClick={() => {
                                    handleSelectSuggestion(suggestion, setFieldValue)
                                  }}
                                >
                                  {suggestion.display_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12 col-md-6">
                          <b>Address Line 2</b>
                          <input
                            value={values.address2}
                            type="text"
                            className="form-control"
                            id="address2"
                            name="address2"
                            onChange={(e) => {
                              setFieldValue("address2", e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <b>City *</b>
                          <input
                            type="text"
                            className={`form-control ${touched.city && errors.city ? "is-invalid" : ""
                              }`}
                            id="city"
                            name="city"
                            value={values.city}
                            onChange={(e) => {
                              setFieldValue("city", e.target.value);
                            }}
                          />
                          {touched.city && errors.city && (
                            <div className="text-danger">{errors.city}</div>
                          )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12 col-md-6">
                          <b>State *</b>
                          <select
                            className={`form-control ${touched.state && errors.state
                              ? "is-invalid"
                              : ""
                              }`}
                            id="state"
                            value={values.state}
                            name="state"
                            onChange={(e) => {
                              setFieldValue("state", e.target.value);
                            }}
                          >
                            {states?.map((state) => (
                              <option key={state} value={state}>
                                {state}
                              </option>
                            ))}
                          </select>
                          {touched.state && errors.state && (
                            <div className="text-danger">{errors.state}</div>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <b>Zip Code *</b>
                          <input
                            type="text"
                            className={`form-control ${touched.zip && errors.zip ? "is-invalid" : ""
                              }`}
                            id="zipCode"
                            name="zip"
                            value={values.zip}
                            onChange={(e) => {
                              setFieldValue("zip", e.target.value);
                            }}
                          />
                          {touched.zip && errors.zip && (
                            <div className="text-danger">{errors.zip}</div>
                          )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12 col-md-12">
                          <b>Complete Physical Address</b>
                          <input
                            type="text"
                            className="form-control"
                            id="physical_address"
                            name="physical_address"
                            onChange={(e) => {
                              setFieldValue(
                                "physical_address",
                                e.target.value
                              ); // Allow manual input
                              setFieldValue("manual_physical_address", true); // Mark as manually edited
                            }}
                            value={
                              values.manual_physical_address
                                ? values.physical_address
                                : [
                                  values.address,
                                  values.address2,
                                  values.city,

                                  values.state,
                                  values.zip,
                                ]
                                  .filter(Boolean)
                                  .join(", ")
                            }
                          />
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12">
                          {data?.region &&
                            Object.keys(data.region).length > 0 && (
                              <>
                                <b>Region/County *</b>
                                <div
                                  className={`d-flex flex-column ${touched.county && errors.county
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "1em",
                                      padding: "1em 0px",
                                      justifyContent: "space-between",
                                      boxSizing: "border-box",
                                    }}
                                    className="add-company-style"
                                  >
                                    {Object.entries(data.region)?.map(
                                      ([regionName, areas]) => (
                                        <div
                                          key={regionName}
                                          style={{
                                            flex: "0 1 calc(20% - 1em)",
                                            border: "1px solid lightgray",
                                            borderRadius: "8px",
                                            padding: "0.5em",
                                            boxShadow:
                                              "0 2px 5px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          {/* Region Checkbox */}
                                          <div
                                            style={{
                                              marginBottom: "0.5em",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={
                                                areas.length > 0
                                                  ? areas.every((area) => values.county?.includes(area))
                                                  : values.county?.includes(regionName)
                                              }
                                              onChange={() => {
                                                if (areas.length > 0) {
                                                  handleRegionSelect(regionName, areas, setFieldValue, values);
                                                } else {
                                                  // Pass the regionName if no areas are present
                                                  handleRegionSelect(regionName, [], setFieldValue, values);
                                                }
                                              }}
                                            />

                                            <label
                                              className="form-check-label"
                                              style={{
                                                marginLeft: "0.5em",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {regionName}{" "}
                                              {areas.length > 0
                                                ? `(all)`
                                                : ""}
                                            </label>
                                          </div>

                                          {/* Areas Checkboxes */}
                                          <div
                                            className="d-flex flex-column"
                                            style={{ gap: "0.5em" }}
                                          >
                                            {areas?.map((area, areaIndex) => (
                                              <div
                                                key={areaIndex}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  checked={values.county?.includes(
                                                    area
                                                  )}
                                                  onChange={() =>
                                                    handleAreaSelect(
                                                      area,
                                                      setFieldValue,
                                                      values
                                                    )
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  style={{
                                                    marginLeft: "0.5em",
                                                  }}
                                                >
                                                  {area}
                                                </label>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                                {touched.county && errors.county && (
                                  <div className="text-danger">
                                    {errors.county}
                                  </div>
                                )}
                              </>
                            )}
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12">
                          <b>Company Overview</b>
                          <Textarea
                            value={values.company_overview}
                            onChange={(e) => {
                              setFieldValue(
                                "company_overview",
                                e.target.value
                              );
                            }}
                            className="form-control"
                            id="overview"
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-12">
                          <b>Revision log message</b>
                          <Textarea
                            value={values.revision_log_message}
                            onChange={(e) => {
                              setFieldValue(
                                "revision_log_message",
                                e.target.value
                              );
                            }}
                            className="form-control"
                            id="logmessage"
                          />

                          <div className="form-text">
                            Briefly describe the changes you have made.
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/*Product Purchased*/}
                  {step === 1 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Products Purchased
                        </Typography>

                        {/* Timber Products Section */}
                        <div className="col-12 col-md-6">
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section1")}
                            >
                              <Typography style={{ fontWeight: "bold" }}>
                                Timber Products
                              </Typography>
                              <button
                                className="navbar-toggler"
                                type="button"
                                aria-controls="section1Content"
                                aria-expanded={isOpen.section1}
                                aria-label="Toggle Property Facts 1"
                              >
                                {isOpen.section1 ? (
                                  <FaAngleUp />
                                ) : (
                                  <FaAngleDown />
                                )}
                              </button>
                            </div>

                            <div
                              className={`collapse ${isOpen.section1 ? "show" : ""
                                }`}
                              id="section1Content"
                            >
                              {isOpen.section1 &&
                                data?.wood_products["Timber Products"].map(
                                  (product, index) => (
                                    <div
                                      className="d-flex"
                                      key={`timber-${index}`}
                                    >
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`timber-${index}`}
                                        value={product}
                                        checked={Purchased?.includes(product)}
                                        onChange={() =>
                                          PurchasedChange(product)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        style={{ marginLeft: "1em" }}
                                        htmlFor={`timber-${index}`}
                                      >
                                        {product}
                                      </label>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        </div>

                        {/* Non-Timber Products Section */}
                        <div className="col-12 col-md-6">
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section2")}
                            >
                              <Typography style={{ fontWeight: "bold" }}>
                                Non-Timber and Special Forest Products
                              </Typography>
                              <button
                                className="navbar-toggler"
                                type="button"
                                aria-controls="section2Content"
                                aria-expanded={isOpen.section2}
                                aria-label="Toggle Property Facts 2"
                              >
                                {isOpen.section2 ? (
                                  <FaAngleUp />
                                ) : (
                                  <FaAngleDown />
                                )}
                              </button>
                            </div>

                            <div
                              className={`collapse ${isOpen.section2 ? "show" : ""
                                }`}
                              id="section2Content"
                            >
                              {isOpen.section2 &&
                                data?.wood_products[
                                  "Non-timber and Special Forest Products"
                                ].map((product, index) => (
                                  <div
                                    className="d-flex"
                                    key={`non-timber-${index}`}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`non-timber-${index}`}
                                      value={product}
                                      checked={Purchased?.includes(product)}
                                      onChange={() =>
                                        PurchasedChange(product)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      style={{ marginLeft: "1em" }}
                                      htmlFor={`non-timber-${index}`}
                                    >
                                      {product}
                                    </label>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <Other
                        otherCheck={

                          unmatchedValues1?.length > 0 || otherCheck1
                        }
                        setOtherCheck={setOtherCheck1}
                        otherValue={otherValue1}
                        setOtherValue={setOtherValue1}
                        setInputValue={setPurchased}
                      />
                    </>
                  )}
                  {/*Product Produce*/}
                  {step === 2 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Products Produced
                        </Typography>
                        <div className="col-12 col-md-6">
                          {/* Timber Products */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section3")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Timber Products
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section3Content"
                                  aria-expanded={isOpen.section3}
                                  aria-label="Toggle Property Facts 3"
                                >
                                  {isOpen.section3 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section3 ? "show" : ""
                                }`}
                              id="section3Content"
                            >
                              {isOpen.section3 && (
                                <div>
                                  {data?.wood_products["Timber Products"].map(
                                    (product, index) => (
                                      <div className="d-flex" key={index}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={index}
                                          value={product}
                                          checked={Produced?.includes(
                                            product
                                          )}
                                          onChange={() =>
                                            ProducedChange(product)
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          style={{ marginLeft: "1em" }}
                                        >
                                          {product}
                                        </label>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          {/* Non-Timber and Special Forest Products */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section4")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Non-Timber and Special Forest Products
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section4Content"
                                  aria-expanded={isOpen.section4}
                                  aria-label="Toggle Property Facts 4"
                                >
                                  {isOpen.section4 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section4 ? "show" : ""
                                }`}
                              id="section4Content"
                            >
                              {isOpen.section4 && (
                                <div>
                                  {data?.wood_products[
                                    "Non-timber and Special Forest Products"
                                  ].map((product, index) => (
                                    <div className="d-flex" key={index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={index}
                                        value={product}
                                        checked={Produced?.includes(product)}
                                        onChange={() =>
                                          ProducedChange(product)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        style={{ marginLeft: "1em" }}
                                      >
                                        {product}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <Other
                        otherCheck={
                          unmatchedValues2?.length > 0 || otherCheck2
                        }
                        setOtherCheck={setOtherCheck2}
                        otherValue={otherValue2}
                        setOtherValue={setOtherValue2}
                        setInputValue={setProduced}
                      />
                    </>
                  )}
                  {/*Species*/}
                  {step === 3 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Species
                        </Typography>
                        <div className="col-12 col-md-6">
                          {/* Softwoods */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section5")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Select Softwoods
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section5Content"
                                  aria-expanded={isOpen.section5}
                                  aria-label="Toggle Property Facts 5"
                                >
                                  {isOpen.section5 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section5 ? "show" : ""
                                }`}
                              id="section5Content"
                            >
                              <div>
                                {data?.species["Softwoods"].map(
                                  (species, index) => (
                                    <div className="d-flex" key={index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`softwood-${index}`}
                                        value={species}
                                        checked={Species?.includes(species)}
                                        onChange={() =>
                                          SpeciesChange(species)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        style={{ marginLeft: "1em" }}
                                      >
                                        {species}
                                      </label>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          {/* Hardwoods */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section6")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Select Hardwoods
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section6Content"
                                  aria-expanded={isOpen.section6}
                                  aria-label="Toggle Property Facts 6"
                                >
                                  {isOpen.section6 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section6 ? "show" : ""
                                }`}
                              id="section6Content"
                            >
                              {isOpen.section6 && (
                                <div>
                                  {data?.species["Hardwoods"].map(
                                    (species, index) => (
                                      <div className="d-flex" key={index}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`hardwood-${index}`}
                                          value={species}
                                          checked={Species?.includes(species)}
                                          onChange={() =>
                                            SpeciesChange(species)
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          style={{ marginLeft: "1em" }}
                                        >
                                          {species}
                                        </label>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <Other
                        otherCheck={
                          unmatchedValues3?.length > 0 || otherCheck3
                        }
                        setOtherCheck={setOtherCheck3}
                        otherValue={otherValue3}
                        setOtherValue={setOtherValue3}
                        setInputValue={setSpecies}
                      />
                    </>
                  )}
                  {/*Services*/}
                  {step === 4 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Services
                        </Typography>
                        <div className="col-12 col-md-6">
                          {/* Forestry Services */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section7")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Select Forestry Services
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section7Content"
                                  aria-expanded={isOpen.section7}
                                  aria-label="Toggle Property Facts 7"
                                >
                                  {isOpen.section7 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section7 ? "show" : ""
                                }`}
                              id="section7Content"
                            >
                              {isOpen.section7 && (
                                <div>
                                  {data?.services["Forestry Services"].map(
                                    (service, index) => (
                                      <div className="d-flex" key={index}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`forestry-${index}`}
                                          value={service}
                                          checked={Services?.includes(
                                            service
                                          )}
                                          onChange={() =>
                                            ServicesChange(service)
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          style={{ marginLeft: "1em" }}
                                        >
                                          {service}
                                        </label>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          {/* Manufacturing / Secondary Manufacturing */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section8")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Select Manufacturing / Secondary
                                  Manufacturing Services
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section8Content"
                                  aria-expanded={isOpen.section8}
                                  aria-label="Toggle Property Facts 8"
                                >
                                  {isOpen.section8 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section8 ? "show" : ""
                                }`}
                              id="section8Content"
                            >
                              {isOpen.section8 && (
                                <div>
                                  {data?.services[
                                    "Manufacturing / Secondary manufacturing"
                                  ].map((service, index) => (
                                    <div className="d-flex" key={index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`manufacturing-${index}`}
                                        value={service}
                                        checked={Services?.includes(service)}
                                        onChange={() =>
                                          ServicesChange(service)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        style={{ marginLeft: "1em" }}
                                      >
                                        {service}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <Other
                        otherCheck={
                          unmatchedValues4?.length > 0 || otherCheck4
                        }
                        setOtherCheck={setOtherCheck4}
                        otherValue={otherValue4}
                        setOtherValue={setOtherValue4}
                        setInputValue={setServices}
                      />
                    </>
                  )}
                  {/*Equipment*/}
                  {step === 5 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Equipment
                        </Typography>

                        <div className="col-12 col-md-6">
                          {/* Select Equipment */}
                          <div className="block out-side-block">
                            <div
                              className="d-flex justify-content-between align-items-center coll"
                              onClick={() => toggleCollapse("section9")}
                            >
                              <div>
                                <Typography style={{ fontWeight: "bold" }}>
                                  Select Equipment
                                </Typography>
                              </div>
                              <div>
                                <button
                                  className="navbar-toggler"
                                  type="button"
                                  aria-controls="section9Content"
                                  aria-expanded={isOpen.section9}
                                  aria-label="Toggle Property Facts 9"
                                >
                                  {isOpen.section9 ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className={`collapse ${isOpen.section9 ? "show" : ""
                                }`}
                              id="section9Content"
                            >
                              {isOpen.section9 && (
                                <div>
                                  {data?.equipments.map((item, index) => (
                                    <div className="d-flex" key={index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`equipment-${index}`}
                                        value={item}
                                        checked={Equipment?.includes(item)}
                                        onChange={() => EquipmentChange(item)}
                                      />
                                      <label
                                        className="form-check-label"
                                        style={{ marginLeft: "1em" }}
                                      >
                                        {item}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <Other
                        otherCheck={
                          unmatchedValues5?.length > 0 || otherCheck5
                        }
                        setOtherCheck={setOtherCheck5}
                        otherValue={otherValue5}
                        setOtherValue={setOtherValue5}
                        setInputValue={setEquipment}
                      />
                    </>
                  )}
                  {/*Log Buying Preferences*/}
                  {step === 6 && (
                    <>
                      <Typography
                        style={{
                          fontSize: "1.2em",
                          color: "black",
                          marginBottom: "0.5em",
                        }}
                      >
                        Log Buying Preferences
                      </Typography>

                      <div className="form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="accept_bid_logs"
                          name="accept_bid_logs"
                          checked={bidlog}
                          onChange={(e) => {
                            console.log('e', e);

                            setbidlog(e.target.checked)
                          }
                          }
                        />
                        <label
                          htmlFor="accept_bid_logs"
                          className="form-check-label"
                        >
                          Accepts Big Logs
                        </label>
                      </div>

                      <div className="row mb-2">

                        <div className="col-12 col-md-6">
                          <label
                            htmlFor="length_preference"
                            className="form-label"
                          >
                            Length Preference (ft):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="length_preference"
                            name="length_preference"
                            value={lengthpref}
                            onChange={(e) => setlengthpref(e.target.value)}
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            htmlFor="diameter_preference"
                            className="form-label"
                          >
                            Diameter Preference (in):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="diameter_preference"
                            name="diameter_preference"
                            value={diapref}
                            onChange={(e) => setdiapref(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12 col-md-6">

                          <label htmlFor="max_length" className="form-label">
                            Maximum Length (ft):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="max_length"
                            name="max_length"
                            value={maxlength}
                            onChange={(e) => setmaxlength(e.target.value)}
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            htmlFor="max_diameter"
                            className="form-label"
                          >
                            Maximum Diameter (in):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="max_diameter"
                            name="max_diameter"
                            value={maxdia}
                            onChange={(e) => setmaxdia(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-12 col-md-6">
                          <label htmlFor="min_length" className="form-label">
                            Minimum Length (ft):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="min_length"
                            name="min_length"
                            value={minlength}
                            onChange={(e) => setminlength(e.target.value)}
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            htmlFor="min_diameter"
                            className="form-label"
                          >
                            Minimum Diameter (in):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="min_diameter"
                            name="min_diameter"
                            value={mindia}
                            onChange={(e) => setmindia(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            htmlFor="speciesPreference"
                            className="form-label"
                          >
                            Species Preference
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="speciesPreference"
                            name="speciesPreference"
                            value={speciespref}
                            onChange={(e) => setspeciespref(e.target.value)}
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label
                            htmlFor="annual_production"
                            className="form-label"
                          >
                            Annual Production (MBF):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="annual_production"
                            name="annual_production"
                            value={annualproduction}
                            onChange={(e) => setannualproduction(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "1em" }}>
                        <div className="col-12">
                          <label htmlFor="notes" className="form-label">
                            Notes
                          </label>
                          <textarea
                            className="form-control"
                            id="notes"
                            name="notes"
                            value={notes}
                            onChange={(e) => setnotes(e.target.value)}
                            placeholder="Enter any additional notes"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {/*Company Contacts*/}
                  {step === 7 && (
                    <>
                      <Typography
                        style={{
                          fontSize: "1.2em",
                          color: "black",
                          marginBottom: "0.5em",
                        }}
                      >
                        Company Contacts
                      </Typography>

                      <FieldArray name="company_contacts">
                        {({ remove, push }) => (
                          <>
                            {values.company_contacts.map((contact, index) => (
                              <div
                                key={index}
                                style={{
                                  border: "2px solid lightgray",
                                  padding: "1em",
                                  marginBottom: "1em",
                                }}
                              >
                                <div className="row mb-2">
                                  <div className="col-12 col-md-6">
                                    <label className="form-label">Name *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name={`company_contacts[${index}].name`}
                                      value={contact.name}
                                      // onBlur={handleBlur}
                                      onChange={(e) => {
                                        // Update Formik value
                                        setFieldValue(
                                          `company_contacts[${index}].name`,
                                          e.target.value
                                        );

                                        // Update local state
                                        const updatedContacts = [
                                          ...companyContacts,
                                        ];
                                        updatedContacts[index].name =
                                          e.target.value;
                                        setCompanyContacts(updatedContacts);
                                      }}
                                    />
                                    {errors.company_contacts && errors.company_contacts[index] && errors.company_contacts[index].name && touched.company_contacts?.[index]?.name && (
                                      <div className="text-danger">{errors.company_contacts[index].name}</div>
                                    )}
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <label className="form-label">
                                      Email *
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      name={`company_contacts[${index}].email`}
                                      value={contact.email}
                                      // onBlur={handleBlur}
                                      onChange={(e) => {
                                        // Update Formik value
                                        setFieldValue(
                                          `company_contacts[${index}].email`,
                                          e.target.value
                                        );

                                        // Update local state
                                        const updatedContacts = [
                                          ...companyContacts,
                                        ];
                                        updatedContacts[index].email =
                                          e.target.value;
                                        setCompanyContacts(updatedContacts);
                                      }}
                                    />
                                    {errors.company_contacts && errors.company_contacts[index] && errors.company_contacts[index].email && touched.company_contacts?.[index]?.email && (
                                      <div className="text-danger">{errors.company_contacts[index].email}</div>
                                    )}
                                  </div>
                                </div>

                                <div className="row mb-2">
                                  <div className="col-12 col-md-6">
                                    <label className="form-label">
                                      Phone *
                                    </label>
                                    <input
                                      type="tel"
                                      inputMode='numeric'
                                      className="form-control"
                                      name={`company_contacts[${index}].phone`}
                                      value={contact.phone}
                                      onBlur={handleBlur}
                                      maxLength={10}
                                      onInput={(e) => {
                                        // Sanitize input by allowing only digits
                                        const sanitizedValue = e.target.value.replace(/[^0-9]/g, "");

                                        // Update Formik value
                                        setFieldValue(`company_contacts[${index}].phone`, sanitizedValue);

                                        // Update local state
                                        const updatedContacts = [...companyContacts];
                                        updatedContacts[index].phone = sanitizedValue;
                                        setCompanyContacts(updatedContacts);
                                      }}
                                      onChange={(e) => {
                                        // Update value on change event
                                        const value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits

                                        // Update Formik field value
                                        setFieldValue(`company_contacts[${index}].phone`, value);

                                        // Update local state
                                        const updatedContacts = [...companyContacts];
                                        updatedContacts[index].phone = value;
                                        setCompanyContacts(updatedContacts);
                                      }}
                                    />

                                    {errors.company_contacts && errors.company_contacts[index] && errors.company_contacts[index].phone && touched.company_contacts?.[index]?.phone && (
                                      <div className="text-danger">{errors.company_contacts[index].phone}</div>
                                    )}
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <label className="form-label">
                                      Website
                                    </label>
                                    <input
                                      type="url"
                                      className="form-control"
                                      name={`company_contacts[${index}].website`}
                                      value={contact.website}
                                      onChange={(e) => {
                                        // Update Formik value
                                        setFieldValue(
                                          `company_contacts[${index}].website`,
                                          e.target.value
                                        );

                                        // Update local state
                                        const updatedContacts = [
                                          ...companyContacts,
                                        ];
                                        updatedContacts[index].website =
                                          e.target.value;
                                        setCompanyContacts(updatedContacts);
                                      }}
                                    />
                                  </div>
                                </div>

                                <Typography
                                  onClick={() => {
                                    remove(index);

                                    // Update local state when removing contact
                                    const updatedContacts = [
                                      ...companyContacts,
                                    ];
                                    updatedContacts.splice(index, 1);
                                    setCompanyContacts(updatedContacts);
                                  }}
                                  style={{
                                    marginTop: "1em",
                                    color: "#a5bf45",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                >
                                  Remove Contact
                                </Typography>
                              </div>
                            ))}

                            <Typography
                              onClick={() => {
                                push({
                                  name: "",
                                  email: "",
                                  phone: "",
                                  website: "",
                                });

                                // Update local state when adding new contact
                                const updatedContacts = [
                                  ...companyContacts,
                                  {
                                    name: "",
                                    email: "",
                                    phone: "",
                                    website: "",
                                  },
                                ];
                                setCompanyContacts(updatedContacts);
                              }}
                              style={{
                                marginTop: "1em",
                                color: "#a5bf45",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                            >
                              Add Contact
                            </Typography>
                          </>
                        )}
                      </FieldArray>
                    </>
                  )}

                  {/*Certification*/}
                  {step === 8 && (
                    <>
                      <div className="row mb-2">
                        <Typography
                          style={{
                            fontSize: "1.2em",
                            color: "black",
                            marginBottom: "0.5em",
                          }}
                        >
                          Certification
                        </Typography>
                        <div className="col-12">
                          <div className="d-flex flex-wrap flex-column">
                            {data?.certifications.map((item, index) => (
                              <div className="d-flex" key={index}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`cert-${index}`}
                                  value={item}
                                  checked={certifications?.includes(item)}
                                  onChange={() =>
                                    handleCertificationChange(item)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  style={{ marginLeft: "1em" }}
                                  htmlFor={`cert-${index}`}
                                >
                                  {item}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <Other
                        otherCheck={
                          unmatchedValues8?.length > 0 || otherCheck8
                        }
                        setOtherCheck={setOtherCheck8}
                        step="true"
                        otherValue={otherValue8}
                        setOtherValue={setOtherValue8}
                        setInputValue={setCertifications}
                      />
                    </>
                  )}
                  {step === 9 && (<>
                    <div className="map-desc"
                      style={{
                        height: '2em',
                        marginBottom: '2em',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                      <Typography style={{ marginLeft: '1em', fontWeight: 'bold' }}> If the pointer on a map is not showing the correct location, you can  adjust it by clicking on the desired spot on the map to reposition the pointer to that exact location.</Typography></div>
                    <Map
                      address={{
                        lat: coords?.x || editData?.x || "",
                        lng: coords?.y || editData?.y || "",
                      }}
                      click={true}
                      setCoords={setCoords}
                      dragable={dragable}
                    />
                  </>
                  )}
                </div>
                <div
                  className="d-flex justify-content-end"
                  style={{ margin: "2em 0em 6em 0em" }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8]?.includes(step) && (
                    <Typography
                      onClick={handleSave}
                      className="sav-btn"
                      style={{
                        color: " #a5bf45",
                        fontWeight: "bold",
                        marginRight: "1em",
                        cursor: "pointer",
                        marginTop: "1.3em",
                      }}
                    >
                      SAVE & EXIT
                    </Typography>
                  )}

                  {step === 0 ? (
                    <button
                      type="button"
                      className="btn-outline-dark1"
                      onClick={handleCancel}
                    >
                      CANCEL
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn-outline-dark1"
                      style={{ padding: "0em 1em" }}
                      onClick={() => {
                        // setOtherCheck(false);
                        dispatch(previousstep());
                      }}
                    >
                      BACK
                    </button>
                  )}

                  {step === 9 ? (
                    <button
                      type="submit"
                      className=" btn-primary2"
                      onClick={handleSave}
                    >
                      FINISH
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className=" btn-primary2"
                    // onClick={() => {
                    //   if (step !== 0) {
                    //     onSubmit()
                    //     dispatch(nextstep());
                    //   }
                    // }}
                    >
                      NEXT STEP
                    </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default AddCompany;
